// import HomeBanner from "../HomeBanner";
// import HomeAbout from "../cards";
// import ProdutosSection from "../HomeProdutoSection"
// import MeioAmbienteSection from "../HomeMeioAmbienteSection";
// import HomeCertificado from "../HomeCertificado"
// import HomeCards from "../HomeCards"
// import HomeQualidade from "../HomeQualidade"


// const HomeContent = () => {
//     return (
//         <>  
//             <HomeBanner />
//             <HomeAbout />
//             <HomeCards/>
//             <ProdutosSection/>
//             <HomeQualidade/>
//             <MeioAmbienteSection/>
//             <HomeCertificado/>
//         </>
//     );
// };

// export default HomeContent;

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import HomeBanner from "../HomeBanner";
import HomeAbout from "../HomeCardMgSul";
import ProdutosSection from "../HomeProdutoSection"
import MeioAmbienteSection from "../HomeMeioAmbienteSection";
import HomeCertificado from "../HomeCertificado"
import HomeCards from "../HomeCards"
import HomeQualidade from "../HomeQualidade"


function Home() {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const scrollTo = params.get("scroll");

        if (!scrollTo) return;

        const scrollToSection = () => {
            const target = document.getElementById(`${scrollTo}-section`);
            if (target) {
                target.scrollIntoView({ behavior: "smooth" });
            } else {
                requestAnimationFrame(scrollToSection); // tenta novamente no próximo frame
            }
        };

        scrollToSection();
    }, [location]);



    return (
        <>
            <HomeBanner />
            <HomeAbout />
            <HomeCards />
            <ProdutosSection />
            <HomeQualidade />
            <MeioAmbienteSection />
            <HomeCertificado />
        </>
    );
}

export default Home;
